var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 36,
    y1: 0.765,
    x2: 36,
    y2: 99.265,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#51842a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#609631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#6da737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#77b33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#7ebb3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#83c140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85c441"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 .7l27 26.9v71.6H0V.7h45z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .7l27 26.9v71.6H0V.7h45z",
    fillOpacity: 0,
    stroke: "#528228",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 91.3l6.8-10.4L9 71.4h4.7l4 6.4 3.9-6.4h4.7L20.2 81 27 91.3h-4.9l-4.4-6.9-4.5 6.9H8.4zm20.8 0V71.5h4v16.4h10.1v3.4H29.2zm16-6.5l3.9-.4c.2 1.3.7 2.3 1.4 2.9.7.6 1.7.9 2.9.9 1.3 0 2.3-.3 2.9-.8s1-1.2 1-1.9c0-.5-.1-.9-.4-1.2-.3-.3-.8-.6-1.5-.9-.5-.2-1.6-.5-3.2-.9-2.2-.5-3.7-1.2-4.6-2-1.2-1.1-1.8-2.4-1.8-4 0-1 .3-2 .9-2.8.6-.9 1.4-1.6 2.5-2 1.1-.5 2.4-.7 3.9-.7 2.5 0 4.4.5 5.7 1.6s1.9 2.6 2 4.4l-4 .2c-.2-1-.5-1.8-1.1-2.2-.6-.4-1.4-.7-2.6-.7-1.2 0-2.1.2-2.8.7-.4.3-.6.7-.6 1.2s.2.9.6 1.2c.5.4 1.8.9 3.7 1.3s3.4.9 4.4 1.4 1.7 1.2 2.2 2c.5.9.8 1.9.8 3.2 0 1.1-.3 2.2-1 3.2s-1.5 1.7-2.7 2.2-2.6.7-4.4.7c-2.5 0-4.5-.6-5.8-1.7s-2-2.7-2.3-4.9z",
    fill: "#fff"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 16.371,
    y1: 37.002,
    x2: 55.488,
    y2: 76.117,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#619530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#60942f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#5b8e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#538429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#487723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#3a671b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#29520f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244d0b"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8 61.4H35.2v-2c2.2-.1 3.5-.3 4.2-.6.6-.3.9-.6.9-1 0-.2-.1-.6-.3-1.1s-.5-1.1-.9-1.7c-.6-1-1.4-2.3-2.4-3.8s-2.1-3.1-3.2-4.8c-3.6 4.2-6 7-6.9 8.4-1 1.4-1.5 2.3-1.5 2.8 0 .2 0 .4.1.6.1.2.3.3.6.5.2.1.7.3 1.3.4.6.1 1.3.2 2.1.3v2H14.8v-2c.7-.1 1.3-.1 1.8-.2.4-.1.9-.2 1.3-.4 1-.5 1.9-1.1 2.7-1.8.8-.7 1.6-1.6 2.4-2.5 1.2-1.4 2.6-2.9 4.1-4.7 1.5-1.7 3.1-3.6 4.8-5.6-1.6-2.4-3.2-4.8-4.8-7-1.6-2.3-3-4.2-4.1-5.8-.6-.8-1.2-1.6-2.1-2.4-.8-.8-1.7-1.4-2.6-1.7-.5-.2-1-.4-1.5-.5-.6-.1-1.2-.2-2-.3v-2h22.6v2c-1.8.1-3.1.2-3.9.5-.8.2-1.3.6-1.3 1.1 0 .2.1.6.2.9.2.4.5 1 1 1.8.4.7 1.1 1.7 1.9 3 .9 1.3 1.9 2.9 3 4.6 3.3-3.9 5.3-6.5 6.2-7.6.8-1.2 1.3-2 1.3-2.4 0-.5-.2-.9-.7-1.1-.5-.3-1.6-.5-3.4-.6v-2h14.4v2c-.7 0-1.2.1-1.6.2-.4.1-.9.3-1.5.5-1.1.5-2 1.1-2.7 1.8-.7.7-1.5 1.5-2.4 2.5-1.3 1.4-2.5 2.8-3.7 4.2-1.2 1.3-2.6 3-4.3 4.9 2.1 3.2 3.9 5.8 5.4 7.9 1.5 2.1 2.9 4.1 4.3 6 .5.8 1.2 1.6 2 2.4.8.8 1.7 1.4 2.6 1.7.4.2.9.3 1.4.4.5.1 1.3.2 2.1.3l.1 1.9z",
    fill: "url(#b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 45.034,
    y1: 72.367,
    x2: 58.534,
    y2: 85.867,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#f0f4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#e8eeca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#dde7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#cfddad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#bed298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#a9c481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#91b566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#78a647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#619932"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .7l27 26.9H45V.7z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .7l27 26.9H45V.7z",
    fillOpacity: 0,
    stroke: "#528228",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.849ffe374a14498719cb7156c654b5da.svg";
export { ForwardRef as ReactComponent };